import { render, staticRenderFns } from "./SubstitutionContent.vue?vue&type=template&id=0b203816&scoped=true&"
import script from "./SubstitutionContent.vue?vue&type=script&lang=ts&"
export * from "./SubstitutionContent.vue?vue&type=script&lang=ts&"
import style0 from "./SubstitutionContent.vue?vue&type=style&index=0&id=0b203816&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b203816",
  null
  
)

export default component.exports